export default "__VITE_ASSET__hhynta5m__"